import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { WorkplaceMap } from "@/components/app/WorkplaceMap";
import { GeofenceControls } from "@/components/app/GeofenceControls";
import { api, formatError } from "@/lib/api";

const blank = (policy) => ({ name: "", address: "", lat: null, lng: null, place_id: null, geofence_radius_m: policy?.default_radius_m || 150, location_verification: policy?.require_location ?? true, offsite_policy: policy?.offsite_policy || "flag" });

export const WorkplaceDialog = ({ open, onOpenChange, workplace, policy, onSaved }) => {
  const [form, setForm] = useState(workplace || blank(policy));
  const [busy, setBusy] = useState(false);
  const patch = (p) => setForm((f) => ({ ...f, ...p }));
  const save = async () => {
    if (!form.name.trim()) { toast.error("Give the workplace a name"); return; }
    setBusy(true);
    const body = { name: form.name, address: form.address, lat: form.lat, lng: form.lng, place_id: form.place_id, geofence_radius_m: form.geofence_radius_m, location_verification: form.location_verification, offsite_policy: form.offsite_policy };
    try {
      const { data } = workplace ? await api.patch(`/workplaces/${workplace.workplace_id}`, body) : await api.post("/workplaces", body);
      toast.success(workplace ? "Workplace updated" : "Workplace added");
      onSaved(data);
      onOpenChange(false);
    } catch (err) {
      toast.error(formatError(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-h-[92vh] max-w-3xl overflow-y-auto" data-testid="workplace-dialog">
        <DialogHeader><DialogTitle>{workplace ? "Edit workplace" : "Add workplace"}</DialogTitle></DialogHeader>
        <div className="grid gap-6 md:grid-cols-2">
          <div className="space-y-4">
            <div className="space-y-1.5"><Label>Workplace name</Label><Input value={form.name} onChange={(e) => patch({ name: e.target.value })} className="h-11 rounded-xl" data-testid="workplace-name-input" /></div>
            <div className="space-y-1.5"><Label>Address</Label><Input value={form.address || ""} onChange={(e) => patch({ address: e.target.value })} className="h-11 rounded-xl" data-testid="workplace-address-input" /></div>
            <GeofenceControls value={form} onChange={patch} idPrefix="workplace" />
          </div>
          <WorkplaceMap value={form} radius={form.geofence_radius_m} onChange={patch} height={280} />
        </div>
        <div className="flex justify-end gap-2 pt-2">
          <Button variant="ghost" onClick={() => onOpenChange(false)} data-testid="workplace-cancel-btn">Cancel</Button>
          <Button onClick={save} disabled={busy} className="rounded-full bg-[#00A85C] hover:bg-[#008F4F]" data-testid="workplace-save-btn">{busy ? "Saving…" : "Save workplace"}</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
